import i18n from "../../../../i18n"

export enum MAINTENANCE_FIELD_IDS {
  SERVICE_NAME = 'SERVICE_NAME',
  DATE_OF_SERVICE = 'DATE_OF_SERVICE',
  DATE = 'DATE',
  ODOMETER = 'ODOMETER',
  ODOMETER_READING = 'ODOMETER_READING',
  SERVICE_DURATION = 'SERVICE_DURATION',
  SERVICE_COST = 'SERVICE_COST',
  COMMENT = 'COMMENT',
  FILES = 'FILES',
  ADD_MONTH_INTERVAL = 'ADD_MONTH_INTERVAL',
  ESTIMATED_DURATION = 'ESTIMATED_DURATION',
  EMAIL = 'EMAIL',
  MONTH_INTERVAL = 'MONTH_INTERVAL',
  NEXT_SCHEDULED_SERVICE_DATE = 'NEXT_SCHEDULED_SERVICE_DATE',
  KM_INTERVAL = 'KM_INTERVAL',
  NEXT_SCHEDULED_DATE = 'NEXT_SCHEDULED_DATE',
  ONE_TIME_SERVICE = 'ONE_TIME_SERVICE',
  EDIT_NOTE = 'EDIT_NOTE',
  NOT_PERFORMED = 'NOT_PERFORMED',
  FIRST_SERVICE = 'FIRST_SERVICE'
}

export const MAINTENANCE_FIELDS = {
  [MAINTENANCE_FIELD_IDS.SERVICE_NAME]: {
    label: i18n.t('Service name'),
    type: 'text',
    path: 'description',
    text: i18n.t('This is a column name field. It only serves to remind yourself what this service is about.')
  },
  [MAINTENANCE_FIELD_IDS.DATE_OF_SERVICE]: {
    label: i18n.t('Date of service'),
    type: 'date',
    path: 'recdate',
    visible: (data: Record<string, any>) => typeof data.cancelled !== 'undefined' ? !data.cancelled : true
  },
  [MAINTENANCE_FIELD_IDS.DATE]: {
    label: i18n.t('Date of service'),
    type: 'date',
    path: 'date',
    visible: (data: Record<string, any>) => typeof data.cancelled !== 'undefined' ? !data.cancelled : true
  },
  [MAINTENANCE_FIELD_IDS.ODOMETER]: {
    label: i18n.t('Odometer reading'),
    type: 'number',
    path: 'odometer',
    text: i18n.t('Whole numbers only.'),
    visible: (data: Record<string, any>) => typeof data.cancelled !== 'undefined' ? !data.cancelled : true
  },
  [MAINTENANCE_FIELD_IDS.ODOMETER_READING]: {
    label: i18n.t('Odometer reading'),
    type: 'number',
    path: 'actual_value',
    text: i18n.t('Whole numbers only.'),
    visible: (data: Record<string, any>) => typeof data.cancelled !== 'undefined' ? !data.cancelled : true
  },
  [MAINTENANCE_FIELD_IDS.SERVICE_DURATION]: {
    label: i18n.t('Service duration in hours (optional)'),
    type: 'number',
    path: 'duration',
    text: i18n.t('Input the number of hours that it will take to perform this service. Only whole numbers are available.'),
    visible: (data: Record<string, any>) => typeof data.cancelled !== 'undefined' ? !data.cancelled : true
  },
  [MAINTENANCE_FIELD_IDS.SERVICE_COST]: {
    label: i18n.t('Service cost (optional)'),
    type: 'number',
    path: 'cost',
    text: i18n.t('Total cost of the service performed in ISK.'),
    visible: (data: Record<string, any>) => typeof data.cancelled !== 'undefined' ? !data.cancelled : true
  },
  [MAINTENANCE_FIELD_IDS.COMMENT]: {
    label: i18n.t('Comment (optional)'),
    type: 'textarea',
    path: 'comment',
  },
  [MAINTENANCE_FIELD_IDS.FILES]: {
    label: i18n.t('Documents related to the service'),
    type: 'file',
    path: 'service_instance_attachments',
    maxFiles: 5,
    text: i18n.t('Max file size is 500kb. Supported files are .jpg and .png. You can upload a maximum of 5 files.')
  },
  [MAINTENANCE_FIELD_IDS.KM_INTERVAL]: {
    label: i18n.t('Kilometers interval'),
    type: 'number',
    path: 'interval',
    text: i18n.t('Number of kilometers between service instances. Only whole numbers are available.'),
    visible: (data: Record<string, any>) => data.type === 'milage',
    readonly: (data: Record<string, any>) => !!data.id
  },
  [MAINTENANCE_FIELD_IDS.NEXT_SCHEDULED_DATE]: {
    label: i18n.t('Next scheduled service'),
    type: 'number',
    path: 'next_service',
    text: i18n.t('This is the next scheduled service point in the service manual.'),
    visible: (data: Record<string, any>) => !!data.id,
    readonly: () => true
  },
  [MAINTENANCE_FIELD_IDS.FIRST_SERVICE]: {
    label: i18n.t('First service'),
    type: 'number',
    path: 'first',
    text: i18n.t('Point when schedual first takes place.'),
    visible: (data: Record<string, any>) => data.type === 'milage',
    readonly: (data: Record<string, any>) => !!data.id,
  },
  [MAINTENANCE_FIELD_IDS.ADD_MONTH_INTERVAL]: {
    label: i18n.t('Add a month interval (optional)'),
    type: 'checkbox',
    path: 'add_interval',
    text: i18n.t('Note: if you input both kilometers and months interval the software will consider whatever comes first.'),
    visible: (data: Record<string,any>) => data.type === 'milage',
    readonly: (data: Record<string, any>) => !!data.id,
    children: (data: Record<string, any>) => data.add_interval ? [{
      id: MAINTENANCE_FIELD_IDS.MONTH_INTERVAL,
      label: i18n.t('Month interval'),
      type: 'number',
      path: 'interval_day',
      text: i18n.t('Number of months between service instances. Only whole numbers are available.'),
      readonly: (data: Record<string, any>) => !!data.id
    }, {
      id: MAINTENANCE_FIELD_IDS.NEXT_SCHEDULED_SERVICE_DATE,
      label: i18n.t('Next scheduled service date'),
      type: 'date',
      path: 'next_service_date',
      text: i18n.t('This is the next scheduled service point in the service manual.'),
      readonly: (data: Record<string, any>) => !!data.id
    }] : []
  },
  [MAINTENANCE_FIELD_IDS.MONTH_INTERVAL]: {
    id: MAINTENANCE_FIELD_IDS.MONTH_INTERVAL,
    label: i18n.t('Month interval'),
    type: 'number',
    path: 'interval_day',
    text: i18n.t('Number of months between service instances. Only whole numbers are available.'),
    visible: (data: Record<string, any>) => data.type === 'date',
    readonly: (data: Record<string, any>) => !!data.id
  },
  [MAINTENANCE_FIELD_IDS.NEXT_SCHEDULED_SERVICE_DATE]: {
    id: MAINTENANCE_FIELD_IDS.NEXT_SCHEDULED_SERVICE_DATE,
    label: i18n.t('Next scheduled service date'),
    type: 'date',
    path: 'next_service_date',
    text: i18n.t('This is the next scheduled service point in the service manual.'),
    visible: (data: Record<string, any>) => data.type === 'date',
    readonly: (data: Record<string, any>) => !!data.id
  },
  [MAINTENANCE_FIELD_IDS.ESTIMATED_DURATION]: {
    label: i18n.t('Estimated duration in hours (optional)'),
    type: 'number',
    path: 'estimated_duration',
    text: i18n.t('Input the number of hours that it will take to perform this service. Leave "0" or empty if this does not apply. Only whole numbers are available.')
  },
  [MAINTENANCE_FIELD_IDS.EMAIL]: {
    label: i18n.t('Email'),
    type: 'tag-text',
    path: 'emails',
    text: i18n.t('You will receive a notification 500km or two weeks before the service is due.'),
    buttonLabel: i18n.t('New email')
  },
  [MAINTENANCE_FIELD_IDS.ONE_TIME_SERVICE]: {
    label: i18n.t('One-time service'),
    type: 'checkbox',
    path: 'one_time_service',
    text: i18n.t("Check this box if you don't want to repeat this check over a month interval.")
  },
  [MAINTENANCE_FIELD_IDS.EDIT_NOTE]: {
    label: i18n.t('Note'),
    type: 'infobox',
    text: i18n.t(`
      It is not possible to change value of <strong>kilometers interval</strong>, <strong>next scheduled service</strong>
      or <strong>next scheduled service date</strong> you will need to delete this schedule and create a new one.</ br>
      Deleting it will not effect the data gathered so far.
    `),
    visible: (data: Record<string, any>) => !!data.id
  },
  [MAINTENANCE_FIELD_IDS.NOT_PERFORMED]: {
    label: i18n.t("Mark as 'not performed'"),
    type: 'checkbox',
    path: 'cancelled',
    text: i18n.t("Check this box if this service hasn't been performed")
  }
}